export function isResultFieldFilled(value) {
  return value !== '' && value !== null && value !== undefined
}

export function hasCompleteMatchResult(home, away) {
  if (!isResultFieldFilled(home) || !isResultFieldFilled(away)) return false

  const homeNum = Number(home)
  const awayNum = Number(away)

  return (
    Number.isInteger(homeNum)
    && homeNum >= 0
    && Number.isInteger(awayNum)
    && awayNum >= 0
  )
}

export function hasMatchStarted(kickoffIso) {
  if (!kickoffIso) return false

  const kickoffMs = new Date(kickoffIso).getTime()
  return Number.isFinite(kickoffMs) && Date.now() >= kickoffMs
}

export function isMissingResultMatch({ kickoff, home, away, tracksResult = true }) {
  if (!tracksResult) return false
  if (!hasMatchStarted(kickoff)) return false
  return !hasCompleteMatchResult(home, away)
}
